const OAUTH_FLOW_STORAGE_KEY = 'thetavern.oauth.pending';
const OAUTH_FLOW_TTL_MS = 15 * 60 * 1000;

const storageAvailable = () =>
  typeof window !== 'undefined' && Boolean(window.sessionStorage);

export const markOAuthFlowStarted = ({ provider = '', returnTo = '' } = {}) => {
  if (!storageAvailable()) return;

  try {
    window.sessionStorage.setItem(
      OAUTH_FLOW_STORAGE_KEY,
      JSON.stringify({
        createdAt: Date.now(),
        provider,
        returnTo,
      })
    );
  } catch {
    // Social sign-in still works through the backend, but callback tokens will be rejected.
  }
};

export const consumePendingOAuthFlow = () => {
  if (!storageAvailable()) return false;

  try {
    const raw = window.sessionStorage.getItem(OAUTH_FLOW_STORAGE_KEY);
    window.sessionStorage.removeItem(OAUTH_FLOW_STORAGE_KEY);

    if (!raw) return false;

    const parsed = JSON.parse(raw);
    const createdAt = Number(parsed?.createdAt || 0);

    return createdAt > 0 && Date.now() - createdAt <= OAUTH_FLOW_TTL_MS;
  } catch {
    return false;
  }
};

export const __oauthFlowStorageKey = OAUTH_FLOW_STORAGE_KEY;
